import { createAction } from 'Lib/reduxUtils';

import type {
  ClaimOfferPayload,
  SetOfferSeenPayload,
  SetOfferSeenSuccessPayload,
} from 'Store/offer/types';

import {
  CLAIM_OFFER,
  SET_OFFER_SEEN,
  SET_OFFER_SEEN_SUCCESS,
  SET_SUB_OFFER_NOTIFICATION_SHOWN,
} from './constants';

export const claimOffer = createAction(CLAIM_OFFER, (payload: ClaimOfferPayload) => payload);

export const setOfferSeen = createAction(SET_OFFER_SEEN, (payload: SetOfferSeenPayload) => payload);

export const setOfferSeenSuccess = createAction(
  SET_OFFER_SEEN_SUCCESS,
  (payload: SetOfferSeenSuccessPayload) => payload
);

export const setSubOfferNotificationShown = createAction(SET_SUB_OFFER_NOTIFICATION_SHOWN);
